module.exports = __webpack_public_path__ + "static/img/Higher Brothers.1bb0d15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Higher Brothers.jpg
// module id = JQZ8
// module chunks = 1